<div *ngIf="nbOfErrors>0 && formService.stateChangeAttempted" class="errorPill">{{nbOfErrors}}</div>
